
import { mapState, mapActions } from 'vuex'

import AppBar from './app-bar'
import tracking from '@/components/tools/tracking'
import Subjects from '@/components/account/messages/Subjects.vue'
import Notifications from '@/components/tools/notifications'
import Cm24Snackbar from '@/components/ui/Cm24Snackbar'
import MerchantPopups from '@/components/merchant/MerchantPopups.vue'
import Cm24SystemBar from '@/components/ui/Cm24SystemBar.vue'

export default {
  components: { Subjects, Notifications, Cm24Snackbar, AppBar, MerchantPopups, Cm24SystemBar },
  data () {
    return {
      title: 'caravanmarkt24'
    }
  },
  async fetch () {
    if (this.loggedIn) {
      try {
        await Promise.all([
          this.getCustomer(),
          this.getCustomerAttributes()
        ])

        const languageSetting = this.customer?.languageSetting
        if (languageSetting) {
          this.$i18n.setLocale(languageSetting)
        }
      } catch (e) {
        // console.error(e)
      }
    }
  },
  computed: {
    ...mapState('messages', {
      activeTitle: state => state.subjects[state.activeSubjectIdx]?.title
    }),
    ...mapState('customer', {
      customer: state => state.customer,
      customerAddress: state => state.customerAddress,
      merchant: state => state.merchant,
      merchantAddress: state => state.merchantAddress,
      customerId: state => state.customer?.customerId,
      emailVerified: state => state.customer?.emailVerified,
      merchantId: state => state.merchant?.merchantId,
      privateProfileCompleted: state => state.customer?.privateProfileCompleted,
      commercialProfileCompleted: state => state.customer?.commercialProfileCompleted,
      merchantProfileCompleted: state => state.customer?.merchantProfileCompleted,
      merchantBlocked: state => state.customer?.merchantBlocked,
      profileType: state => state.profileType,

      isMerchant: state => state.merchant?.merchantId !== null
    }),
    isThread () {
      return this.$route.name.includes('account-messages-thread-slug')
    },
    loggedIn () {
      return this.$auth.loggedIn
    },
    appBarColor () {
      if (
        this.$store?.state?.auth?.user &&
        this.$store?.state?.auth?.user['http://cm24.de/roles'] &&
        this.$store?.state?.auth?.user['http://cm24.de/roles'].includes('admin')) {
        return 'secondary'
      } else {
        return 'white'
      }
    }
  },
  async mounted () {
    try {
      await this.getAndSetDifferenceToServerTime()
    } catch (e) {
      // console.error(e)
    }

    try {
      if (this.$route.query.mc === 'thai8Iezimie' || this.merchantId) {
        await this.getMerchantCookie(this.$route.query.mc)
      }
    } catch (e) {
      // console.error(e)
    }

    try {
      this.$nextTick(async () => {
        if (this.loggedIn) {
          if (this.emailVerified === false && this.$auth.user?.email_verified === true) {
            if (this.merchantId) {
              const { data } = await this.$axios.put('/private/merchant/check-email-verified', {})
              if (data === 'MERCHANT_COMPLETE_AND_EMAIL_VERIFIED') {
                await this.getCustomer()
              }
            } else if (this.profileType === 'COMMERCIAL') {
              const { data } = await this.$axios.put('/private/customer/commercial/check-email-verified', {})
              if (data === 'COMMERCIAL_COMPLETE_AND_EMAIL_VERIFIED') {
                await this.getCustomer()
              }
            } else {
              const { data } = await this.$axios.put('/private/customer/check-email-verified', {})
              if (data === 'PRIVATE_COMPLETE_AND_EMAIL_VERIFIED') {
                await this.getCustomer()
              }
            }
          }

          if (this.profileType === 'COMMERCIAL' && !this.commercialProfileCompleted) {
            const { data } = await this.$axios.put('/private/customer/commercial/ack-if-account-complete', {})
            if (data === 'COMMERCIAL_COMPLETE_AND_EMAIL_VERIFIED') {
              await this.getCustomer()
            }
          } else if (this.profileType === 'MERCHANT' && !this.merchantProfileCompleted) {
            const { data } = await this.$axios.put('/private/merchant/ack-if-account-complete', {})
            if (data === 'MERCHANT_COMPLETE_AND_EMAIL_VERIFIED') {
              await this.getCustomer()
            }
          } else if (this.profileType === 'PRIVATE' && !this.privateProfileCompleted) {
            const { data } = await this.$axios.put('/private/customer/ack-if-account-complete', {})
            if (data === 'PRIVATE_COMPLETE_AND_EMAIL_VERIFIED') {
              await this.getCustomer()
            }
          }

          if (this.merchantId) {
            try {
              this.$gtm.push({
                event: 'set_merchant_id',
                merchantId: this.merchantId
              })
            } catch (e) {
              console.error(e)
            }
          }
        }

        try {
          const { customer, merchant, customerAddress, merchantAddress } = this.$store.state.customer
          const customerData = tracking.getUserData(customer, merchant, customerAddress, merchantAddress)
          this.$gtm.init(customerData)

          this.$tapfiliate.init(this)
        } catch (e) {
          console.error(e)
        }
      })
    } catch (e) {
      console.error(e)
    }
  },
  methods: {
    ...mapActions('customer', ['getCustomer', 'getMerchantCookie', 'getCustomerAttributes']),
    ...mapActions('general', ['getAndSetDifferenceToServerTime'])
  }
}
